import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getData } from "../../../utils/fetch";

export const getDataPartnership = createAsyncThunk(
  "partnership/getData",
  async (args, { rejectWithValue }) => {
    try {
      const result = await getData(`/cms/partners`);
      return result.data.data;
    } catch (error) {
      rejectWithValue(error.response.data);
    }
  }
);

const partnershipSlice = createSlice({
  name: "partnership",
  initialState: {
    data: [],
    page: 1,
    limit: 10,
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getDataPartnership.pending, (state, action) => {
        state.status = "loading";
      })
      .addCase(getDataPartnership.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })
      .addCase(getDataPartnership.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export default partnershipSlice.reducer;
